import { SearchResult } from '#server/models';
import { featureConfig } from '@/env-exports';
import {
  ResultCard,
  ResultCardDescription,
  ResultCardHeader,
  ResultCardTitle,
  ResultCardLink,
  ResultCardTag,
  ResultCardContent,
  ResultCardMedia,
  Badge,
  Divider,
  HighlightedText,
} from '@/components';
import { cn, formatDisplayDate } from '@/utils';

export interface NewsResultCardProps {
  result: SearchResult;
}

export const NewsResultCard = ({ result }: NewsResultCardProps) => {
  const newsDetails = result.newsDetails!;

  return (
    <ResultCardLink to={newsDetails.url} result={result}>
      <ResultCard className={cn((result.forYou ?? false) && 'border-highlight-border bg-highlight-bg')}>
        <div className="grow">
          <ResultCardHeader>
            <ResultCardTag>
              {(result.forYou ?? false) && <Badge className="mr-2 bg-ring text-white">For You</Badge>}
              <Badge variant={(result.forYou ?? false) ? 'forYou' : 'secondary'}>News</Badge>
            </ResultCardTag>
            <ResultCardTitle>{newsDetails.title}</ResultCardTitle>
            <ResultCardDescription>
              <HighlightedText text={newsDetails.description} />
            </ResultCardDescription>
          </ResultCardHeader>
          <ResultCardContent>
            <Divider className={cn((result.forYou ?? false) && 'bg-highlight-divider')} />
            <div
              className={cn(
                'mt-4 flex flex-col gap-2 rounded-lg bg-primary-website-background-colour px-5 py-3 text-sm md:flex-row md:gap-16',
                (result.forYou ?? false) && 'bg-white',
              )}
            >
              <div className="flex md:gap-8">
                <div className="w-28 font-semibold md:w-auto">Published</div>
                <div className="text-secondary-grey-01">{formatDisplayDate(newsDetails.publishedDate)}</div>
              </div>
              <div className="flex md:gap-8">
                <div className="w-28 font-semibold md:w-auto">Last Updated</div>
                <div className="text-secondary-grey-01">{formatDisplayDate(newsDetails.lastUpdated)}</div>
              </div>
            </div>
          </ResultCardContent>
        </div>
        {featureConfig.showEventsNewsPictures && newsDetails.imageUrl && (
          <ResultCardMedia src={newsDetails.imageUrl} alt="Event" />
        )}
      </ResultCard>
    </ResultCardLink>
  );
};
